import { render, staticRenderFns } from "./storeInfoStatisticsfrom.vue?vue&type=template&id=66016d14&scoped=true&"
import script from "./storeInfoStatisticsfrom.vue?vue&type=script&lang=js&"
export * from "./storeInfoStatisticsfrom.vue?vue&type=script&lang=js&"
import style0 from "./storeInfoStatisticsfrom.vue?vue&type=style&index=0&id=66016d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66016d14",
  null
  
)

export default component.exports